module.exports = __webpack_public_path__ + "static/media/how_tr.962a5279.vtt";